import * as fns from 'date-fns';
import dayjs from 'dayjs';

const DATE_FORMAT = 'yyyy-MM-dd';

const formatDate = (date: string | Date | dayjs.Dayjs) => {
    if (!date) return '';
    const jsDate =
        typeof date === 'string'
            ? new Date(date)
            : dayjs.isDayjs(date)
              ? date.toDate()
              : date;
    return fns.format(jsDate, DATE_FORMAT);
};

type GenerateReportTitleArgs = {
    rightsholders?: string[] | null;
    sponsors?: string[] | null;
    startDate?: string | Date | dayjs.Dayjs;
    endDate?: string | Date | dayjs.Dayjs;
};

function generateReportTitle(
    values: GenerateReportTitleArgs,
    {
        rightsholdersById,
        sponsorsById,
        clientName,
    }: {
        rightsholdersById?: Record<number, { name: string }> | null;
        sponsorsById?: Record<number, { name: string }> | null;
        clientName: string;
    },
) {
    const rhIds = values.rightsholders ?? [];
    const rightsholder = rightsholdersById?.[parseInt(rhIds[0], 10)];

    const sponsorIds = values.sponsors ?? [];
    const isSingleSponsor = sponsorIds.length === 1;
    const isMultipleSponsors = sponsorIds.length > 1;
    let sponsorName = 'allsponsors';
    if (isSingleSponsor) {
        sponsorName = sponsorsById?.[parseInt(sponsorIds[0])]?.name || '';
    }
    if (isMultipleSponsors) {
        sponsorName = `${sponsorIds.length} Sponsors`;
    }

    const rhName =
        rhIds.length > 1 ? clientName : rightsholder?.name || clientName;
    let reportTitle = `${rhName}_${sponsorName}`.replace(/\s/g, '');

    if (!values.startDate && !values.endDate) {
        reportTitle += '_alldates';
    }

    if (values.startDate) {
        const startFormatted = formatDate(values.startDate);
        reportTitle += `_${startFormatted}`;
        const endFormatted = formatDate(values.endDate || new Date());
        reportTitle += `_${endFormatted}`;
    }

    return reportTitle;
}

export default generateReportTitle;
